import Layer from "@arcgis/core/layers/Layer";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { composeIsoAndIsDeletedWhereCondition } from "../../components/Filter/ApplyFilters";
import {
  setReports,
  setReportsLayer,
  setReportsLayerMap,
} from "../../redux/action/Dashboard-action";
import { getLayerFromId, isdeletedFieldName } from "../../utils/API";
import { ROLE_EDITOR } from "../../utils/helper";

const useReports = (config) => {
  const view = useSelector((state) => state.mapViewReducer.view);
  const reportsLayerRef = useRef([]);

  const timer = useRef();
  const refreshTimer = useRef();
  const watchHandlers = useRef([]);
  const dispatch = useDispatch();

  const processReportsLayer = useCallback(
    async (config, layer) => {
      timer.current = setTimeout(async () => {
        try {
          if (!layer) return;

          layer = await layer.load();
          if (!layer) return;

          layer.layerConfig = config.layerConfig["pacReports"];
          layer.layerConfig.alias = "pacReports";

          const query = layer.createQuery();
          const whereString =
            query.where && query.where.length > 0 ? query.where : "";
          query.where =
            whereString.length > 0
              ? `(${query.where}) AND (currvalidationfield IN (1,2,5,6,10))`
              : "currvalidationfield IN (1,2,5,6,10)";

          const composedString = composeIsoAndIsDeletedWhereCondition(
            layer,
            config
          );

          if (
            !composedString.includes(isdeletedFieldName) &&
            layer.fields.some((f) => f.name === isdeletedFieldName)
          ) {
            query.where =
              composedString +
              " and ((isdeleted is null) or (isdeleted=0) or (isdeleted=2)) AND currvalidationfield IN (1,2,5,6,10)";
          } else {
            query.where =
              composedString + " AND currvalidationfield IN (1,2,5,6,10)";
          }

          const res = await layer.queryFeatures(query);
          const layerFeaturesMap = {};
          let newUpdates = 0;
          if (!Array.isArray(res?.features)) return;

          const features = res.features || [];
          newUpdates += res.features.filter(
            (feat) =>
              feat.attributes.currvalidationfield === 1 &&
              feat.attributes.reporttype === 1
          ).length;

          features.forEach((feature) => {
            let layerId = feature.attributes?.reportedlayerid;
            const reportType = feature.attributes?.reporttype;
            if (!layerId) {
              // layerId = reportLayerConfigId;
            } // skip if no reportedlayerid
            if (!layerFeaturesMap[layerId]) {
              layerFeaturesMap[layerId] = [];
            }
            const hasReport = layerFeaturesMap[layerId].some(
              (f) => f.getObjectId() === feature.getObjectId()
            );
            if (!hasReport) layerFeaturesMap[layerId].push(feature);
          });

          dispatch(setReportsLayerMap(layerFeaturesMap));
          dispatch(setReports(features));
          dispatch(setReportsLayer(layer || null));
        } catch (error) {
          console.error("Error loading layers and querying features:", error);
        }
      }, 1000);
    },
    [view]
  );

  const getReportLayer = useCallback(async () => {
    try {
      let layer = await getLayerFromId(
        Layer,
        "d397943a41dd47f9ac8d5a4188ff65ec"
      );
      if (layer) {
        layer = await layer.load();
      }
      // console.log(layer);

      return layer;
    } catch (err) {
      console.log(`couldn't get the report layer`, err);
    }

    return null;
  }, []);

  useEffect(() => {
    try {
      if (!view || !config) return;
      if (config.role !== ROLE_EDITOR) return;

      getReportLayer()
        .then((layer) => {
          processReportsLayer(config, layer);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  }, [view, config]);
};

export default useReports;
